import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $ErrorSpacer = styled.div<{ $isCentered?: boolean }>`
  display: block;
  ${({ $isCentered }) =>
    $isCentered &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}
  max-width: ${rem(546)};
  width: 100%;
  margin: ${spacing('lg')} auto;

  & > svg {
    color: ${({ theme }) => theme?.colors?.mainTextColor ?? 'black'};
  }
`;

export const $ErrorContainer = styled.div<{ $isFull: boolean }>`
  height: ${({ $isFull }) => ($isFull ? '100vh' : null)};
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: ${spacing('lg')};
  background: ${({ theme }) =>
    theme?.systemColors?.defaultBackground ?? 'white'};

  align-items: center;
`;
